import PieBar from './PieBar'

export default PieBar



// WEBPACK FOOTER //
// ./src/legacy/components/PieBar/index.js